/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ComponentInterface } from '../../../canvas-common/interfaces/component.interface';
import { TicketContainer } from '@appPlanApplication/tickets/TicketContainer';
import { Component } from '@appCanvasCommon/component-system/Component';
import { EventBinder } from '../interaction-utils';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';

export class TicketHold extends Component implements ComponentInterface {
	/**
	 * Boilerplate for dealing with events.
	 */
	private _binder: EventBinder;
	constructor() {
		super();
	}
	/**
	 * The setup method is called once all properties on a component have been decorated by the ComponentManager.
	 *
	 * From this point on, you can safely use this.getParent() and this.getManager().
	 *
	 * Arguments passed into setup are passed in via the ComponentManager.add(name, component, ...args)
	 */
	public override setup(canvasAngularLand: CanvasAngularLand, dataContainer: TicketContainer) {
		this.canvasAngularLand = canvasAngularLand;
		this._binder = new EventBinder(this.getParent());
		// Add new event binding

		// MOC-3785 - Functionality moved into context menu

		this._binder.add('hammer-pressup', (event: any) => {
			const tappedTicket = dataContainer.getData();

			// if (canvasAngularLand.planState.accessCheck.isReadOnly()){return;}
			dataContainer.cutInLine();

			const selectedTicketList = canvasAngularLand.floatingTickets.editTicket$.getValue().size
				? canvasAngularLand.floatingTickets
				: canvasAngularLand.tickets;

			canvasAngularLand.hoverOverStateService.hoverPosition$.next({
				x: event.center.x,
				y: event.center.y,
			});

			const selectedTicketsMap = canvasAngularLand.tickets.editTicket$.getValue();
			const isTicketSelected = selectedTicketsMap.get(tappedTicket.$id);

			if (!(selectedTicketsMap.size === 1 && isTicketSelected)) {
				canvasAngularLand.hoverOverStateService.updateId(tappedTicket.$id);
				canvasAngularLand.hoverOverStateService.startHover();
			}

			// MOC-4035 - Swapping to new ticket is now single tap
			// if (selectedTicketList.editTicket$.getValue().size) {
			// 	if (!canvasAngularLand.planState.interactionBlocker.check(Interaction.SwitchEditTicket)) { return; }
			//
			// 	const editTickets = selectedTicketList.editTicket$.getValue();
			//
			// 	canvasAngularLand.ticketEditService.logImplicitSave();
			// 	//save and close
			// 	canvasAngularLand.planState.actions.persistTicketData(editTickets, selectedTicketList);
			// 	canvasAngularLand.planState.actions.changeTicketViewToDefault(editTickets, selectedTicketList);
			//
			// 	canvasAngularLand.planState.actions.unSelectTicket(selectedTicketList.selectedTicket$.getValue().list, selectedTicketList);
			// 	canvasAngularLand.planState.actions.selectTicket(tappedTicket);
			//
			// 	//open new one
			// 	canvasAngularLand.planState.actions.changeTicketViewToEdit(tappedTicket);
			//
			// 	// Focus on new ticket
			// 	dataContainer.camera.focusOnTicket(tappedTicket, 0.5);
			// }
			// planState.dependencies.toggleTarget(dataContainer.getData().$id);
		});
	}
	/**
	 * Called on destroy. Clean-up your shit here.
	 */
	public override destroy() {
		this._binder.destroy();
		super.destroy();
	}
}
